import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useOperationStore } from "@/stores/operation";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeFormView',
  emits: ["notice"],
  setup(__props, { emit }) {

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const custom = computed(() => operationStore.customData);


const handleClick = () => {
  emit("notice", false);
};

return { __sfc: true,operationStore, op, custom, emit, handleClick }
}

})